import {createAction, props} from '@ngrx/store';

export const windowResizeAction = createAction(
  '[DOM API] Window Resize',
  props<{width: number; height: number}>()
);
